export function formatIdCardDuty(employee?: any): string {
    return 'Daily Rate';
}
